module.exports = __webpack_public_path__ + "static/media/home-right.f27c982e.webp";